import type { AnyRoute } from "@tanstack/react-router";

import { createFleetMonitoringRoutes as createRoutes } from "./createFleetMonitoringRoutes";
import type { FleetMonitoringRouteDeps } from "./fleetMonitoringRouteContext";

export type {
  FleetMonitoringRouteDeps,
  FleetMonitoringRouteFactory,
} from "./fleetMonitoringRouteContext";

export function createFleetMonitoringRoutes(
  deps: FleetMonitoringRouteDeps,
): AnyRoute[] {
  return [...createRoutes(deps)];
}
